import classnames from 'classnames/bind'

// Lib

// Components
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import useMedia from '@/hooks/useMedia'
// Styles
import styles from './style.module.scss'
import 'react-loading-skeleton/dist/skeleton.css'

const cx = classnames.bind(styles)

interface IProductCard {
  className?: string
  count?: number
  isPromo?: boolean
}

const ProductCardSkeleton = (props: IProductCard) => {
  const { className, count = 1, isPromo } = props
  const { isMobile } = useMedia()

  return (
    <>
      {Array.from(Array(count)).map((_, index) => (
        <div key={index} className={cx('productCard', className)}>
          <div className={cx('productCard__image')}>
            <Skeleton borderRadius={0} containerClassName={cx('productCard__image-carousell')} />
          </div>

          <div className={cx('productCard__info')}>
            <div className={cx('productCard__info-header')}>
              {/* product name */}
              {!isPromo && (
                <>
                  <Skeleton containerClassName={cx('productCard__name')} />

                  <div className={cx('productCard__tags')}>
                    <SkeletonTheme height={'100%'} width={'100%'} borderRadius={4}>
                      <Skeleton containerClassName={cx('productCard__tags-skeleton')} />
                      <Skeleton containerClassName={cx('productCard__tags-skeleton')} />
                      <Skeleton containerClassName={cx('productCard__tags-skeleton')} />
                    </SkeletonTheme>
                  </div>
                  {/* footer */}
                  {
                    <SkeletonTheme borderRadius={100}>
                      <div className={cx('productCard__info-footer')}>
                        <Skeleton width={'50%'} height={20} containerClassName={cx('productCard__discount')} />

                        <div className={cx('productCard__detail')}>
                          <Skeleton width={37} height={16} containerClassName={cx('productCard__detail-original-price')} />
                          <Skeleton width={52} height={16} containerClassName={cx('productCard__detail-sale-quantity')} />
                        </div>
                      </div>
                    </SkeletonTheme>
                  }
                </>
              )}
              {isPromo && (
                <>
                  {isMobile ? (
                    <>
                      <Skeleton containerClassName={cx('productCard__name')} />
                      <Skeleton containerClassName={cx('productCard__name')} />
                    </>
                  ) : (
                    <>
                      <Skeleton containerClassName={cx('productCard__name')} />

                      <div className={cx('productCard__tags')}>
                        <SkeletonTheme height={'100%'} width={'100%'} borderRadius={4}>
                          <Skeleton containerClassName={cx('productCard__tags-skeleton')} />
                          <Skeleton containerClassName={cx('productCard__tags-skeleton')} />
                          <Skeleton containerClassName={cx('productCard__tags-skeleton')} />
                        </SkeletonTheme>
                      </div>
                      {/* footer */}
                      {
                        <SkeletonTheme borderRadius={100}>
                          <div className={cx('productCard__info-footer')}>
                            <Skeleton width={'50%'} height={20} containerClassName={cx('productCard__discount')} />

                            <div className={cx('productCard__detail')}>
                              <Skeleton width={37} height={16} containerClassName={cx('productCard__detail-original-price')} />
                              <Skeleton width={52} height={16} containerClassName={cx('productCard__detail-sale-quantity')} />
                            </div>
                          </div>
                        </SkeletonTheme>
                      }
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default ProductCardSkeleton
